<template>
    <toggle :on="is_on" :data="data" :url="url" class="favourites-button">
        <template slot-scope="{ on, setOff, setOn }">
            <button
                ref="button"
                @click.stop="click(on, setOn, setOff)"
                :class="{
                    'is-active': on,
                    'is-loading': loading,
                }"
            >
                <slot name="default"></slot>

                <transition name="shrink" mode="out-in">
                    <slot name="on" v-if="on"></slot>
                </transition>

                <transition name="shrink" mode="out-in">
                    <slot name="off" v-if="!on"></slot>
                </transition>

                <span class="pl-3" v-if="$slots.label"
                    ><slot name="label"></slot
                ></span>
            </button>
        </template>
    </toggle>
    <!-- button -->
    <!--
  <a
    v-if="add"
    :href="local_faved ? local_remove : local_add"
    @click.prevent="toggle"
    :class="{ 'is-loading': loading, 'is-static': liked }"
    ref="button"
    class="button"
  >
    <span class="icon">
      <slot v-if="!local_faved" name="fav"></slot>
      <slot v-else name="faved"></slot>
    </span>
  </a>
  -->
    <!-- no button -->
    <!--
  <span v-else>{{ total }}</span>

  
  -->
</template>

<script>
import axios from "axios";
import toggle from "../../shared/renderless/WorldspanToggle.js";

const axios_instance = axios.create({
    baseURL: window.user.urls.base,
    timeout: 2000,
    withCredentials: true,
    xsrfCookieName: "csrftoken",
    xsrfHeaderName: "X-CSRFToken",
});
const DEFAULT_CATEGORY = "favourite";
const REGEXP = /\/favourites\/(.*)\/([0-9]+)(?:\/([a-z]+))?/;

const storeMixin = {
    data: function () {
        return {
            sharedState: {
                favourites: window.user.favourites,
            },
        };
    },
};
export default {
    name: "Favorite",
    components: { toggle },
    mixins: [storeMixin],
    props: {
        href: {
            // api endpoint eg: /favourites/sessions/12/like
            required: true,
            type: String,
        },
        message: String, // message to show to user '%s' replaced for `action`
        list: {
            // list to test
            type: Array,
            required: false,
            default: () => [],
        },
    },
    data() {
        return {
            loading: false,
            timeout: 0,
        };
    },
    computed: {
        is_on() {
            return this.id ? this.storeExists(this.id) : false;
        },
        model() {
            let [, model] = REGEXP.exec(this.href) || [];
            return model;
        },
        id() {
            let [, , id] = REGEXP.exec(this.href) || [];
            return parseInt(id);
        },
        category() {
            let [, , , category] = REGEXP.exec(this.href) || [];
            return category || DEFAULT_CATEGORY;
        },
    },

    methods: {
        // called @click with slotProp callback and state
        // toggle state on success only
        async click(isToggledOn, setOn, setOff) {
            this.$refs.button.blur();
            let response = await this.save(!isToggledOn);
            if (response && typeof response !== "string") {
                // all ok.
                try {
                    if (response.status == 201) {
                        setOn();
                    } else {
                        setOff();
                    }
                } catch (error) {
                    console.log(
                        `[error] unable to save user favourites locally. ${error}`
                    );
                }
            } else {
                console.log(
                    `[save] ${response ? response : "Error saving favourite"}`
                );
            }
        },
        showMessage(state) {
            let action = state ? "Added" : "Removed";
            let message = `${action} ${this.category}`;
            if (this.message) {
                message = this.message.replace(
                    "%s",
                    `${action} ${this.category}`
                );
            }
            window._vue_events.$emit("toast-messages:message-create", {
                message: message,
                success: function (id) {
                    setTimeout(function () {
                        window._vue_events.$emit(
                            "toast-messages:message-close",
                            id
                        );
                    }, 4000);
                },
            });
        },

        // called on click
        async save(state) {
            let vm = this;
            if (this.storeIsEmpty()) {
                console.log(`[warn] store null, creating...`);
                await this.storeCreate();
            }
            if (this.id) {
                this.timeout = setTimeout(() => {
                    this.loading = true;
                }, 400);
                return this.fetch(this.href, state)
                    .then(function (response) {
                        vm.showMessage(state);
                        vm.storeUpdate(state);

                        // emit state to parent
                        vm.$emit(`favourite:updated`, [
                            state,
                            response.data,
                            response.status,
                        ]);

                        return response;
                    })
                    .catch(function (error) {
                        let action = state ? "adding" : "removing";
                        let message = `[error] ${action} favourite! ${error.message}`;
                        return message;
                    })
                    .finally(function () {
                        vm.loading = false;
                        clearTimeout(vm.timeout);
                    });
            }
        },
        storeIsEmpty() {
            // return true if store (or a few related properties) are null
            return (
                !Object.prototype.hasOwnProperty.call(this, "category") ||
                (!Object.prototype.hasOwnProperty.call(this, "model") &&
                    typeof this.model !== "undefined") ||
                !Object.prototype.hasOwnProperty.call(this, "sharedState") ||
                !Object.prototype.hasOwnProperty.call(
                    this.sharedState,
                    this.category
                ) ||
                !Object.prototype.hasOwnProperty.call(
                    this.sharedState[this.category],
                    this.model
                )
            );
        },
        // update global source of truth
        storeUpdate(state) {
            // console.log("storeUpdate()", arguments);
            if (state) {
                this.storeAdd();
            } else {
                this.storeRemove();
            }
        },
        // add to array of favourites
        storeAdd() {
            // console.log("storeAdd");
            if (!this.storeExists(this.id)) {
                try {
                    this.sharedState.favourites[this.category][this.model].push(
                        this.id
                    );
                } catch (error) {
                    console.log(`[error] cannot save favourites locally`);
                }
            }
        },
        // remove from array of favourites
        storeRemove() {
            // console.log("storeRemove");
            if (this.storeExists(this.id)) {
                try {
                    this.sharedState.favourites[this.category][
                        this.model
                    ].splice(this.storeFind(), 1);
                } catch (error) {
                    console.log(`[error] cannot remove favourites locally`);
                }
            }
        },
        // does favourite already exist?
        storeExists() {
            // console.log("storeExists");
            return this.storeFind() > -1;
        },
        // where is the current favourite in list, else -1
        storeFind() {
            // console.log("storeFind");
            try {
                return this.sharedState.favourites[this.category][
                    this.model
                ].indexOf(this.id);
            } catch (error) {
                console.log(`[error] cannot find favourites locally`);
                return -1;
            }
        },
        storeCreate() {
            return new Promise((resolve) => {
                // create empty object if not available
                if (
                    !Object.prototype.hasOwnProperty.call(
                        this.sharedState.favourites,
                        this.category
                    )
                ) {
                    this.sharedState.favourites[this.category] = {};
                } else if (
                    !Object.prototype.hasOwnProperty.call(
                        this.sharedState.favourites[this.category],
                        this.model
                    )
                ) {
                    let obj = {};
                    obj[this.model] = [];
                    this.sharedState.favourites[this.category] = obj;
                }
                // make it reactive within this Vue instance (therefore all other components that share `sharedState`)
                this.$set(
                    this.sharedState.favourites[this.category],
                    this.model,
                    this.sharedState.favourites[this.category][this.model]
                );
                // todo: replace with vuex
                setTimeout(() => {
                    resolve(true);
                }, 0);
            });
        },
        // returns axios promise
        fetch(url, state) {
            let method = state ? "post" : "delete";
            const config = { method, url };
            return axios_instance(config)
                .then((response) => {
                    if (response.headers["content-type"].startsWith("text")) {
                        let format =
                            response.headers["content-type"].split(";")[0];
                        let message = `Response not json! "content-type: ${format}"`;
                        // send Object to catch() method
                        throw { message };
                    } else {
                        return response;
                    }
                })
                .catch((error) => {
                    let message = `${error.message}`;
                    throw { message };
                });
        },
    },
};
</script>
